import i18n from "i18next";
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from "react-i18next";

import es from './locales/es/translation.json';
import en from './locales/en/translation.json';

// the translations
// (tip move them in a JSON file and import them,
// or even better, manage them separated from your code: https://react.i18next.com/guides/multiple-translation-files)
const resources = {
    en: {
        translation: en
    },
    es: {
        translation: es
    }
};

// i18n.on('languageChanged', (lng) => {
//     if (i18n.options.whitelist.includes(lng)) {
//         const currentLenguage = window.location.pathname.substring(1, 3);
//         if (i18n.options.whitelist.includes(currentLenguage)) {
//             if (lng !== currentLenguage)
//                 window.location.replace(
//                     window.location.pathname.replace(/\/en\/|\/es\//g, `/${lng}/`)
//                 );
//         } else {
//             window.location.replace(
//                 `/${lng}${window.location.pathname}${window.location.search}`
//             );
//         }
//     }
// });
//@ts-ignore
i18n
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
        fallbackLng: 'es',
        lng: 'es',
        whitelist: ['en', 'es'],
        resources,
        react: {
            useSuspense: false
        },
        interpolation: {
            escapeValue: false // react already safes from xss
        }
    });

export default i18n;